import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { ImmagineFormType } from "../../types"
import ImmagineForm from "./ImmagineForm"
import { Button } from "@inmagik/magik-ui"
import { initialValuesImmagine, validationSchemaImmagine } from "./ImmagineCommon"

export default function ImmagineModal({
  title,
  immagine,
  save,
  show,
  onClose,
  showEdizione = false,
}: {
  title: string
  immagine?: ImmagineFormType
  save: (values: ImmagineFormType, actions: { setErrors: (errors: any) => void }) => Promise<void>
  show: boolean
  onClose: () => void
  showEdizione?: boolean
}) {
  return (
    <Formik
      enableReinitialize
      initialValues={initialValuesImmagine(immagine) as ImmagineFormType}
      validationSchema={validationSchemaImmagine(showEdizione)}
      onSubmit={save}
    >
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} size="lg" backdrop="static">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <ImmagineForm col={12} showEdizione={showEdizione} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
